import { cn } from "@/modern/utils";
import { format } from "date-fns";
import { NotebookPen, ChevronRight, PencilIcon, User, Clock } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { useEntityNotesContext } from "../context/EntityNotesContext";

export const NotesList = () => {
  const { notes, handleSelectNote, canEditNote } = useEntityNotesContext();
  return (
    <div className="space-y-3 relative flex flex-col p-4 w-full overflow-auto">
      {notes.map((note) => {
        const lastEditedDate = format(new Date(note.lastUpdatedAt || note.updatedAt), "MMM d, yyyy");
        const lastEditedBy = note.lastUpdatedBy;
        const lastEditedText = lastEditedBy 
          ? `Last edited ${lastEditedDate} by ${lastEditedBy}`
          : `Last edited ${lastEditedDate}`;
        
        return (
          <button
            key={note.id}
            onClick={() => handleSelectNote(note)}
            className={cn(
              "group w-full p-4 bg-card rounded-lg border border-border/70 text-left transition-all duration-200 hover:border-primary/60 hover:bg-primary/5",
              note.archived && "line-through"
            )}
          >
            <div className="flex items-start gap-2">
              <div className="p-1 rounded-md bg-primary/20 text-primary shrink-0">
                <NotebookPen className="size-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <div className="flex items-center gap-2 min-w-0 truncate">
                    <h4 className="font-medium text-foreground/95 truncate min-w-0 text-sm">
                      {note.name || "Untitled Note"}
                    </h4>
                    {canEditNote(note) && (
                      <PencilIcon className="size-3 shrink-0" />
                    )}
                  </div>
                  <ChevronRight className="w-3 h-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
                </div>
                <div className="flex items-center gap-3 mt-2">
                  {note.creatorName && (
                    <Tooltip delayDuration={300}>
                      <TooltipTrigger asChild>
                        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                          <User className="size-3" />
                          <span className="truncate max-w-[100px]">{note.creatorName}</span>
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>Created by {note.creatorName}</p>
                      </TooltipContent>
                    </Tooltip>
                  )}
                  <Tooltip delayDuration={300}>
                    <TooltipTrigger asChild>
                      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                        <Clock className="size-3" />
                        <span>{lastEditedDate}</span>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>{lastEditedText}</p>
                    </TooltipContent>
                  </Tooltip>
                </div>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
